export enum ReviewMode {
  'ACKNOWLEDGE' = 'ACKNOWLEDGE',
  'ACCEPT_REJECT' = 'ACCEPT_REJECT',
  'FILL_FORM' = 'FILL_FORM',
}
